// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1bIo3","title":"InfoRow_title__2Zuba"};